import { Reducer } from 'redux';
import {
    MonthlyBreakdownReportState,
    MonthlyBreakdownReportStatus,
    emptyMonthlyBreakdownReport
} from './MonthlyBreakdownReportState';

import {
    MONTHLY_BREAKDOWN_REPORT_GET_START,
    MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS,
    MONTHLY_BREAKDOWN_REPORT_GET_ERROR,
    MonthlyBreakdownReportAction
} from 'actions/insights/bookings/monthlyBreakdownReport/MonthlyBreakdownReportActionsTypes';

const initialState: MonthlyBreakdownReportState = {
    report: emptyMonthlyBreakdownReport,
    status: MonthlyBreakdownReportStatus.Initial,
    loading: false
};

export const MonthlyBreakdownReportReducer: Reducer<MonthlyBreakdownReportState, MonthlyBreakdownReportAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case MONTHLY_BREAKDOWN_REPORT_GET_START:
            return {
                ...state,
                status: MonthlyBreakdownReportStatus.Getting,
                loading: true
            };

        case MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS:
            return {
                ...state,
                report: action.payload.report,
                status: MonthlyBreakdownReportStatus.GettingSuccess,
                loading: false
            };

        case MONTHLY_BREAKDOWN_REPORT_GET_ERROR:
            return {
                ...state,
                status: MonthlyBreakdownReportStatus.Error,
                loading: false
            };

        default:
            return state;
    }
};
